var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"train"},[_c('div',{staticClass:"train__image",style:({ backgroundImage: 'url(' + _vm.url + ')' })})])}
var staticRenderFns = []

export { render, staticRenderFns }